/**
 * Conditionally joins class names, dropping falsy values.
 * Intentionally tiny — we don't need a runtime variant of clsx/twMerge for this site.
 */
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ");
}
